import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlingService {
  private errorSource: Subject<string> = new Subject<string>();
  public error$: Observable<string> = this.errorSource.asObservable();

  public setError(error: HttpErrorResponse): void {
    this.errorSource.next(error.message);
  }
}
